import { LocalNotifications } from "@capacitor/local-notifications";

const waitForLocalNotificationsPermission = async () => {
  return new Promise((resolve, reject) => {
    let interval = setInterval(async () => {
      try {
        console.log("Checking local notification permissions");
        const permissions = await LocalNotifications.checkPermissions();
        if (permissions.display === "granted") {
          console.log("Local notification permission granted");
          clearInterval(interval);
          resolve();
        } else if (permissions.display === "denied") {
          console.log("Local notification permission denied");
          clearInterval(interval);
          reject(new Error("Local notification permission denied"));
        }
      } catch (error) {
        // Handle chunk loading errors when offline
        console.warn(
          "Failed to check notification permissions:",
          error.message,
        );
        clearInterval(interval);
        resolve(); // Resolve anyway to not block app startup
      }
    }, 1000);
  });
};

export default waitForLocalNotificationsPermission;
